module.exports = __webpack_public_path__ + "img/logo.34eda4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/logo.png
// module id = 360
// module chunks = 0